var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
import { connect } from "react-redux";
import OrderHdListingsForm from "products/orderHdListings/OrderHdListingsForm";
// Bootstrap
import { Button } from "react-bootstrap";
import { actions } from 'react-redux-form';
// Domain
import * as orderDomain from "products/orderHdListings/OrderHdListings";
// Components
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./OrderHdListingsView.less";
const mapStateToProps = (state) => ({
    orderFormState: state.products.orderHdListings.orderFormState
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let OrderHdListingsView = class OrderHdListingsView extends React.Component {
    componentDidMount() {
    }
    componentWillUnmount() {
    }
    renderFormArea() {
        if (this.props.orderFormState.$form.pending) {
            return (React.createElement("div", { className: styles.holder },
                React.createElement("div", { className: styles.centeredContainer },
                    React.createElement("p", null, "Sending message..."))));
        }
        else if (this.props.orderFormState.$form.submitted) {
            return (React.createElement("div", { className: styles.holder },
                React.createElement("div", { className: styles.centeredContainer },
                    React.createElement("p", { className: styles.title }, "Message Sent!"),
                    React.createElement("p", { className: styles.subTitle }, "We are working hard to keep you updated regarding progress of your order submission."),
                    React.createElement(Button, { bsStyle: "success", onClick: () => this.props.dispatch(actions.reset(orderDomain.pathsOrderHdListingsForm.modelPath)) }, "Send another?"))));
        }
        else {
            return React.createElement(OrderHdListingsForm, { officeId: this.props.params.officeId });
        }
    }
    render() {
        return (React.createElement("div", { className: styles.fullContent },
            React.createElement(PageHeading, { reportName: "Order an HD Listing" }),
            React.createElement(PageContainer, null,
                React.createElement("div", { className: styles.contents },
                    React.createElement("div", { className: styles.paragraph },
                        React.createElement("div", null, "To add High Definition (HD) content to a listing please fill out the form below."),
                        React.createElement("div", null, "Our support team will be in contact to complete your HD order.")),
                    React.createElement("div", { className: styles.paragraph },
                        React.createElement("div", { className: styles.info },
                            React.createElement("span", { className: "fa fa-info-circle" }),
                            "Please add only a ",
                            React.createElement("b", null, "single"),
                            " Address or Listing Reference Number per order."),
                        this.renderFormArea())))));
    }
};
OrderHdListingsView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], OrderHdListingsView);
export default OrderHdListingsView;
